import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ApprovalsInboxPage } from '@/features/approvals/inbox-page';

const searchSchema = z.object({
  kind: z.string().optional().catch(undefined),
  project: z.string().optional().catch(undefined),
  min: z.string().optional().catch(undefined),
  age: z.enum(['today', 'week', 'older']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/approvals')({
  validateSearch: searchSchema,
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  const filters = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ApprovalsInboxPage
      filters={filters}
      onFilters={(next) =>
        void navigate({
          search: { ...next, age: next.age === 'all' ? undefined : next.age },
          replace: true,
        })
      }
    />
  );
}
